import { graphql } from '~gql';

export const LOGIN_WITH_APPLE = graphql(`
  mutation LoginWithApple($input: AppleLoginInput!) {
    loginWithApple(input: $input) {
      token
      user {
        ...SessionUser
      }
    }
  }
`);
